module.exports = __webpack_public_path__ + "static/media/1040113200.83c908b8.jpg";